"use strict";

(function () {
  "use strict";

  config.$inject = ["$stateProvider"];
  angular.module("users").config(config);

  function config($stateProvider) {
    $stateProvider.state("users", {
      url: "/users",
      templateUrl: "app/pages/users/users.html",
      controller: "UsersCtrl",
      controllerAs: "vm",
      title: "Users",
      resolve: {
        ready: function ready($q, $rootScope) {
          var deferred = $q.defer();
          if ($rootScope.$user) {
            deferred.resolve("");
          } else {
            $rootScope.$watch(function () {
              return $rootScope.$user;
            }, function () {
              if ($rootScope.$user) {
                deferred.resolve("");
              }
            }, true);
          }
          return deferred.promise;
        }
      }
    });
  }
})();